document.addEventListener(
  "DOMContentLoaded", () => {
    var MENU = new Mmenu("#my-menu", {
      extensions: ["position-front"],
      navbar: {
        add: false,
      },
      navbars: [{
        "position": "top",
        "content": [
          "<div class='menu_logo'></div>",
        ]
      }],
      "slidingSubmenus": false,
    }, {
      offCanvas: {
        clone: true,
        page: {
          selector: "#app",
        },
      }
    });

    $('.mm-listitem a').on('click touch', function() {
      MENU.close();
    });
    
  }
);
